import { ReferencesResult } from 'app/core/services/api-client';
import { ObjektId } from '@models/objekt-id';

export interface IReferencesState {
  references: ReferencesResult;
  isBusy: boolean;
  id: ObjektId;
}

export const initialState: IReferencesState = {
  references: null,
  isBusy: false,
  id: null,
};
